import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import logoSygnet from '../assets/V1_sygnetb.png';

const EntrigyIntro = ({ onComplete }) => {
  const [stage, setStage] = useState('ventro');

  useEffect(() => {
    // Show "VENTRO - REBRANDING" for 1.4 seconds
    const stageTimer = setTimeout(() => {
      setStage('entrigy');
    }, 1400);

    // Trigger the login form appearance (total 2.8s)
    const completeTimer = setTimeout(() => {
      onComplete();
    }, 2800);

    return () => {
      clearTimeout(stageTimer);
      clearTimeout(completeTimer);
    };
  }, [onComplete]);

  return (
    <div className="w-full h-full flex items-center justify-center overflow-hidden">
      <AnimatePresence mode="wait">
        {stage === 'ventro' ? (
          <motion.div
            key="ventro-stage"
            initial={{ opacity: 0, letterSpacing: '0.2em' }}
            animate={{ opacity: 1, letterSpacing: '0.6em' }}
            exit={{ opacity: 0, scale: 1.05, filter: 'blur(8px)' }}
            transition={{ duration: 0.6, ease: "easeOut" }}
            className="flex flex-col items-center justify-center space-y-4"
          >
            <motion.h2
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              className="text-white font-outfit text-3xl md:text-5xl font-extralight uppercase"
              style={{ letterSpacing: 'inherit' }}
            >
              Ventro
            </motion.h2>
            <motion.div
              initial={{ width: 0 }}
              animate={{ width: 100 }}
              transition={{ delay: 0.3, duration: 0.7 }}
              className="h-[1px] bg-emerald-500/50"
            />
            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 0.6 }}
              transition={{ delay: 0.7 }}
              className="text-emerald-400 text-[10px] uppercase tracking-[0.5em] font-medium"
            >
              Rebranding
            </motion.p>
          </motion.div>
        ) : (
          <motion.div
            key="entrigy-stage"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className="flex flex-col items-center justify-center space-y-10 scale-90 md:scale-100"
          >
            <div className="relative flex items-center justify-center">
              {/* Logo Container */}
              <motion.div
                className="relative w-32 h-32 md:w-44 md:h-44 flex items-center justify-center"
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.8, ease: "easeOut" }}
              >
                <img
                  src={logoSygnet}
                  alt="Ventro Logo"
                  className="w-full h-full object-contain relative z-10"
                />
              </motion.div>
            </div>

            <div className="flex flex-col items-center text-center">
              <motion.h1
                initial={{ opacity: 0, y: 12 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.2 }}
                className="text-white font-outfit text-4xl md:text-6xl font-extralight uppercase tracking-[0.4em]"
              >
                Entrigy
              </motion.h1>

              <motion.div
                initial={{ width: 0, opacity: 0 }}
                animate={{ width: "60%", opacity: 1 }}
                transition={{ duration: 1, delay: 0.6 }}
                className="h-[1px] bg-gradient-to-r from-transparent via-white/30 to-transparent mt-4 w-full max-w-[160px]"
              />

              <motion.p
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 1, delay: 1.1 }}
                className="text-white/30 text-[9px] mt-5 uppercase tracking-[0.4em] font-light max-w-[250px]"
              >
                Powering the Sustainable Future
              </motion.p>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default EntrigyIntro;
